var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"yellow-button",class:_vm.className,attrs:{"type":_vm.type},on:{"click":_vm.handleClick,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }